module.exports = __webpack_public_path__ + "static/media/fl_cast_jwilgus.182ea505.jpg";